import { useRef, useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { CalendarInput } from "../components/FormComps";
import { getApiSetting, postApiSetting } from "../assets/functions";
import { ToastContainer, toast } from 'react-toastify';
import { NavLink,useNavigate } from "react-router-dom";

export default function DashboardPayout ({setAuth}) {
     const navigate = useNavigate();

    const fromDateRef = useRef(null);
    const toDateRef = useRef(null);

    const [boxData, setBoxData] = useState({
        successCount : '',
        successAmt : '',
        failCount : '',
        failAmt : '',
    });

    useEffect(()=>{
        (async()=>{
            try {
                let res = await fetch('/Admin/api/Admin/dbDataPayout', getApiSetting());
                // console.log("res--",res)
                // console.log("result--",result)
                if(res.status === 200){
                    let result = await res.json();
                    // console.log("result--",result)
                    if(result.data){
                        updateDashboardData(result.data)
                    }
                }
                 else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
            } catch (error) {
                console.log(error)
            }
        })()
    },[])

    const searchData = async () => {
        let fDate = fromDateRef.current.value;
        let tDate = toDateRef.current.value;
        
        if(!fDate || !tDate) {
            alert('Report date are required.')
            return false;
        }
        try {
            let postSetting = postApiSetting({fDate,tDate})
            let res = await fetch('/Admin/api/Admin/dbDataByDatePayout', postSetting);
            // console.log("res search by date-",res)
            if(res.status === 200){
                   let result = await res.json();
                //   console.log("result search by date-",result)
                    if(result.data){
                         updateDashboardData(result.data)
                         updateDashboardData(result.data)
                    }
                    else{
                        console.log("No result.data")
                    }
                }
                 else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }


        } catch (error) {
            console.log(error)
        }
    }

    const updateDashboardData = (data) => {
        setBoxData(prevState => ({
            ...prevState,
            successCount: data.successTxnCount||0,
            successAmt: data.successTxnAmount/100,
            failCount: data.failureTxnCount||0,
            failAmt: data.failureTxnAmount/100,
        }));
    }

    return (<>
        {/* <SidebarNavigation /> */}
        <section className="dashboard-page">
            <Navbar title="DASHBOARD" />
            <div className="container-fluid pe-3">
                <div className="main-content my-3">
                    <h5 className="mb-4 fw-bold">DASHBOARD</h5>
                    <form className="mb-4">
                            <div className="row">
                                <div className="col-md-3 col-lg-2">
                                    <CalendarInput dateRef={fromDateRef} />
                                </div>
                                <div className="col-md-3 col-lg-2">
                                    <CalendarInput dateRef={toDateRef} />
                                </div>
                                <div className="col-md-3 col-lg-2">
                                    <button type="button" className="btn btn-sm text-white _themebg-0" onClick={searchData}>Search</button>
                                </div>
                            </div>
                    </form>
                    <div className="row">
                        <HighlightBox text='Successful Transactions' bg='cornflowerblue' amt={boxData.successCount} icon={<i className="fa-solid fa-chart-line"></i>} />
                        <HighlightBox text='Collection Amount' bg='cadetblue' amt={boxData.successAmt} icon={<i className="fa-solid fa-sack-dollar"></i>} />
                        <HighlightBox text='Failed Transactions' bg='lightcoral' amt={boxData.failCount} icon={<i className="fa-solid fa-magnifying-glass-dollar"></i>} />
                        <HighlightBox text='Failed Amount' bg='darkcyan' amt={boxData.failAmt} icon={<i className="fa-solid fa-handshake"></i>} />
                    </div>
                </div>
            </div>
        </section>
    </>)
}

const HighlightBox = (props) => {
    return (
        <div className="col-sm-12 col-md-6 col-lg-3 mb-3">
            <div className="highlight-box p-4 text-white d-flex justify-content-between rounded h-100" style={{backgroundColor:props.bg}}>
                <span className="hb-icon">{props.icon}</span>
                <div className="hb-text text-end mt-3">
                    <h6>{props.text}</h6>
                    <strong className="d-block">{props.amt}</strong>
                </div>
            </div>
        </div>
    )
}